.wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  flex-shrink: 0;
}

.triggerBtn {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #eff4ff;
  border: 1px solid #b6c4ff;
  color: #00236f;
  font-family: var(--font-sans, 'Inter', sans-serif);
  font-size: 0.72rem;
  font-weight: 800;
  font-style: italic;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: all 0.14s ease;
  user-select: none;
}

.triggerBtn:hover {
  background: #dce9ff;
  border-color: #00236f;
  transform: scale(1.06);
}

.triggerOnDark {
  background: rgba(255, 255, 255, 0.18);
  border-color: rgba(255, 255, 255, 0.42);
  color: #ffffff;
}

.triggerOnDark:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: #ffffff;
}

.triggerActive {
  background: #00236f;
  border-color: #00236f;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 35, 111, 0.28);
}

.popoverCard {
  position: absolute;
  top: calc(100% + 8px);
  width: min(310px, 84vw);
  background: #ffffff;
  border: 1px solid #d5e3fc;
  border-radius: 12px;
  padding: 0.78rem 0.9rem;
  box-shadow: 0 16px 36px rgba(13, 28, 46, 0.16);
  z-index: 95;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  text-align: left;
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
}

.popoverLeft {
  left: 0;
}

.popoverRight {
  right: 0;
}

.popoverCenter {
  left: 50%;
  transform: translateX(-50%);
}

.popoverHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding-bottom: 0.32rem;
  border-bottom: 1px solid #eff4ff;
}

.popoverTitle {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.8rem;
  font-weight: 800;
  color: #00236f;
  line-height: 1.25;
}

.closeBtn {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  color: #444651;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 700;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
}

.closeBtn:hover {
  background: #dce9ff;
  color: #00236f;
}

.popoverBody {
  font-family: var(--font-sans, 'Inter', sans-serif);
  font-size: 0.76rem;
  color: #444651;
  line-height: 1.45;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.popoverBody strong {
  color: #0d1c2e;
  font-weight: 700;
}
